import component from './card';

export default function install(Vue, { name = undefined } = {}) { // eslint-disable-line no-unused-vars
  Vue.component((name ? name : component.name), component);
}
